// src/refracted Dashboard/UserProfile.js - Updated version with database integration
import React from "react";
import { usePlayerContext } from "../../hooks/PlayerContext";
import { useUserDatabase } from '../../hooks/useUserDatabase';

const UserProfile = () => {
  const { state } = usePlayerContext();
  // Get database user info
  const { user: dbUser, isAuthenticated } = useUserDatabase();
  
  // Use database user data if available, fallback to platform data
  const userData = dbUser || state.userData;
  const platform = state.platform;

  if (!userData) return null;

  // Enhanced user info display
  const getDisplayInfo = () => {
    if (isAuthenticated && dbUser) {
      // Show database user info
      return {
        name: dbUser.displayName || dbUser.email,
        subtitle: `${platform ? `Connected to ${platform}` : 'No platform connected'}`,
        avatar: dbUser.displayName?.[0]?.toUpperCase() || dbUser.email?.[0]?.toUpperCase() || 'U'
      };
    } else if (platform && state.userData) {
      // Show platform user info (guest or legacy)
      return {
        name: platform === "spotify" ? (state.userData?.display_name || 'Connected User') : state.userData?.snippet?.title,
        subtitle: platform === "spotify" ? (state.userData?.email || platform) : state.userData?.snippet?.customUrl,
        avatar: null // Use platform image
      };
    }
    
    return {
      name: 'Guest User',
      subtitle: 'Limited features - Create account for full experience',
      avatar: 'G'
    };
  };

  const displayInfo = getDisplayInfo();
  const imageUrl = !isAuthenticated && platform === "spotify"
    ? state.userData?.images?.[0]?.url
    : state.userData?.snippet?.thumbnails?.default?.url;

  return (
    <div className="profile-card">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="User Profile"
          className="profile-image"
          style={{ borderRadius: "50%", width: "80px", height: "80px" }}
        />
      ) : (
        // Fallback avatar for database users
        <div className="profile-avatar" style={{
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #4e7fff, #8c4eff)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "2rem",
          fontWeight: "600"
        }}>
          {displayInfo.avatar}
        </div>
      )}
      
      <h3>{displayInfo.name}</h3>
      <p>{displayInfo.subtitle}</p>
      
      {/* Show account type indicator */}
      {isAuthenticated && (
        <div className="account-badge" style={{
          background: "rgba(29, 185, 84, 0.2)",
          color: "#1db954",
          padding: "0.3rem 0.8rem",
          borderRadius: "20px",
          fontSize: "0.8rem",
          marginTop: "0.5rem"
        }}>
          ✅ Phantom Account
        </div>
      )}
      
      {!isAuthenticated && localStorage.getItem('guestSession') && (
        <div className="guest-badge" style={{
          background: "rgba(255, 193, 7, 0.2)",
          color: "#856404",
          padding: "0.3rem 0.8rem",
          borderRadius: "20px",
          fontSize: "0.8rem",
          marginTop: "0.5rem"
        }}>
          👤 Guest Session
        </div>
      )}
    </div>
  );
};

export default UserProfile;